import { Routes } from '@angular/router';
import {
  SurveyAbandonedComponent,
  SurveyCompletedComponent,
  SurveyIntroComponent,
  SurveyQuestionnaireService,
  SurveyThankYouComponent,
  SurveyViewComponent
} from '@brightside-web/desktop/feature/survey-questionnaire';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { OnboardingSurveyComponent } from './onboarding-survey/onboarding-survey.component';
import { OnboardingStepsService } from './onboarding-steps.service';
import { onboardingSurveyGuard } from './onboarding-survey.guard';

export const onboardingRoutes: Routes = [
  {
    path: '',
    component: OnboardingComponent,
    providers: [OnboardingStepsService, SurveyQuestionnaireService],
    children: [
      {
        path: 'survey',
        canActivate: [onboardingSurveyGuard],
        children: [
          {
            path: ':type',
            component: OnboardingSurveyComponent,
            children: [
              { path: 'intro', component: SurveyIntroComponent },
              { path: 'view', component: SurveyViewComponent },
              { path: 'thank-you', component: SurveyThankYouComponent },
              { path: 'completed', component: SurveyCompletedComponent },
              { path: 'abandoned', component: SurveyAbandonedComponent },
            ],
          }
        ]
      }
    ]
  }
]

